module.exports = __webpack_public_path__ + "img/Brake shoe.2731407f.jpg";